<template>
  <v-container fluid class="pt-0">
    <div v-sticky="48">
      <v-row class="py-1" style="margin-top: -12px !important; margin-bottom: -12px !important;">
        <v-col class="px-1" cols="12" align="right">
          <icon-button
            :tooltip="$t('TeljesKepernyo')"
            icon="fa-desktop"
            @click="toggleFullscreen()"
          />
        </v-col>
      </v-row>
    </div>

    <v-row class="mx-0">
      <h3 class="ml-3">{{ $t('Funkciok') }}</h3>
    </v-row>

    <v-row class="justify-start my-2 ml-3">
      <v-btn outlined class="src-btn">
        <v-icon x-small>fa-search</v-icon>
      </v-btn>

      <input
        type="text"
        :placeholder="$t('KozpontiKereses')"
        class="k-textbox py-2 px-2"
        v-model="search"
        style="z-index: 1"
      />

      <v-btn outlined class="infobtn">
        <v-icon x-small style="color: blue" class="mr-0">fa-info-circle</v-icon>
      </v-btn>
    </v-row> 

    <v-divider class="mt-3"></v-divider>

    <v-row class="pt-3">
      <v-col v-if="routerViewCol == 9" cols="3">
        <div min-width="150px" class="settingsMenu">
          <router-link tag="div" to="/settings" class="link">
            <v-row class="pt-3">
              <v-col class="align-center justify-center ">
                <h3 class="mb-1">{{ $t('Penzugy') }}</h3>
                <p style="font-weight: normal">
                  {{ $t('PenznemekArfolyamokBeallitasa') }}
                </p>
              </v-col>
            </v-row>
          </router-link>
        </div>
        <div v-for="item in filteredMenus" :key="item.title" class="mb-0">
          <MenuItem :item="item" />
        </div>
      </v-col>

      <v-col :cols="routerViewCol">
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import configuration from "@/models/Configuration";
import MenuItem from "./Components/MenuItem.vue";
import IconButton from "@/components/IconButton.vue";
import { t } from "@/plugins/i18n";

function filtered(settingsChildren) {
  return settingsChildren.filter((x) =>
    [
      "/settings/banks",
      "/approval-matrix",
      "/document-templates",
      "/user-acc-no",
      "/account-codes/list",
      "/parameters",
      "/roles",
      "/tax",
      "/taxes",
      "/generalLedgerInvoiceMirror",
      "/invoice-parameter",
      "/general-ledger/transaction-items",
    ].includes(x.url.toLocaleLowerCase())
  );
}

export default {
  name: "SettingsPage",

  components: {
    MenuItem,
    IconButton
  },

  mounted() {
    this.routerViewCol = this.$route.path == "/settings" ? 9 : this.routerViewCol;
    localStorage.setItem("routerViewCol", JSON.stringify(this.routerViewCol));
  },

  data: () => ({
    configuration,
    routerViewCol: JSON.parse(localStorage.getItem("routerViewCol")) || 9,
    search: "",
    menuItems: [
      {
        title: t("Bankok"),
        url: "/settings/banks",
      },
      {
        title: t("FolyoszamlaMuveletek"),
        url: "/settings/account/action-source",
      },
      {
        title: t("FizetesiModok"),
        url: "/settings/payment-mode",
      },
      {
        title: t("KontirozasEgyediParameterezese"),
        url: "/settings/acc-item-param",
      },
      {
        title: t("FolyoszamlaTetelCsoportok"),
        url: "/settings/account/account-type",
      },
      {
        title: t("Koltseghelyek"),
        url: "/settings/invoice-group",
      },
      {
        title: t("IndirektKoltseghelyJovahagyasok"),
        url: "/settings/invoice-group-approvals",
      },
      {
        title: t("Penztarak"),
        url: "/settings/cash-points",
      },
      {
        title: t("ErtesitoTipusok"),
        url: "/invoice-types",
      },
      {
        title: t("ArfolyamAdatok"),
        url: "/currency-rates",
      },
      {
        title: t("FokonyviSzamlak"),
        url: "/user-acc-no",
      },
      {
        title: t("PartnerhezRendeltJovahagyok"),
        url: "/approval-matrix",
      },
      {
        title: t("DokumentumSablonok"),
        url: "/document-templates",
      },
      {
        title: t("BejovoSzamlaTipusok"),
        url: "/incoming-invoice-type",
      },
      {
        title: t("KimenoSzamlaTipusok"),
        url: "/outgoing-invoice/type",
      },
      {
        title: t("BizonylatkonyvTipusok"),
        url: "/account-voucher-types",
      },
      {
        title: t("KonyvelesiFokonyviSzamok"),
        url: "/account-codes/list",
      },
      {
        title: t("RendszerParameterek"),
        url: "/parameters",
      },
      {
        title: t("KonyvelesiDimenziokodTipusok"),
        url: "/dim-code-types",
      },
      {
        title: t("JogosultsagSzerepkorok"),
        url: "/roles",
      },
      {
        title: t("AFAKulcsok"),
        url: "/tax",
      },
      {
        title: t("SzamlatukorEsDimenzioKodok"),
        url: "/generalLedgerPeriods",
      },
      {
        title: t("SzamlatipusokParameterezese"),
        url: "/invoice-parameter",
      },
      {
        title: t("BankimportMozgaskodok"),
        url: "/bank-extract-import-account-type",
      },
      {
        title: t("TargyiEszkozCsoportok"),
        url: "/fix-asset/groups",
      },
      {
        title: t("SzamlaMigracio"),
        url: "/invoice/migration",
      },
      {
        title: t("Bankkartyak"),
        url: "/credit-cards",
      },
      {
        title: t("PCKodok"),
        url: "/pc-codes"
      },
      {
        title: t("EgyebCikkekSzolgaltatasokKarbantarto"),
        url: "/gparts/edit-list",
      },
      {
        title: t("MetisRiportok"),
        url: "/met-riport"
      },
      {
        title: t("FizetesiHataridoKarbantarto"),
        url: "/partner-paydates",
      },
      {
        title: t("CimkeKarbantarto"),
        url: "/object-marks",
      },
    ],
  }),

  methods: {
    toggleFullscreen() {
      this.routerViewCol = this.routerViewCol == 9 ? 12 : 9
      localStorage.setItem("routerViewCol", JSON.stringify(this.routerViewCol));
    }
  },

  computed: {
    filteredMenus() {
      const menuItems = process.env.VUE_APP_SETTINGS_HIDDEN === "true" ? filtered(this.menuItems) : this.menuItems;
      return menuItems.filter((item) => {
        return item.title.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped>
.settingsMenu {
  background-color: white;
  border: thin solid #ddd;
  cursor: pointer;
}

.settingsMenu .router-link-exact-active:hover {
  background-color: var(--primaryColorHover);
}

.settingsMenu:not(.router-link-exact-active):hover {
  background-color: #eee;
}

.src-btn {
  border-left: thin solid #ddd;
  border-top: thin solid #ddd;
  border-bottom: thin solid #ddd;
  border-right: none !important;
  background: rgb(233, 233, 233);
}

.infobtn {
  border-right: thin solid #ddd;
  border-top: thin solid #ddd;
  border-bottom: thin solid #ddd;
  border-left: none !important;
}

.card {
  height: 50px;
}
</style>
